import React from 'react';
import { Link } from 'react-router-dom';
import { Download, FlaskConical, BookOpen, Zap, Brain, Trophy, FileText, ArrowRight } from 'lucide-react';

const principles = [
  { icon: Brain, title: 'Progresszív túlterhelés', description: 'A fejlődés egyetlen valódi motorja' },
  { icon: Zap, title: 'Specifikusság elve', description: 'Edzz arra, amiben fejlődni szeretnél' },
  { icon: FlaskConical, title: 'Regeneráció & alvás', description: 'A növekedés a pihenés alatt történik' },
  { icon: BookOpen, title: 'Periodizáció', description: 'Strukturált terhelés a csúcsteljesítményhez' },
  { icon: Trophy, title: 'Konzisztencia > intenzitás', description: 'A hosszú távú szokás mindent visz' }
];

const LeadMagnetSection = () => {
  return (
    <section 
      id="lead-magnet" 
      data-testid="lead-magnet-section"
      className="py-24 bg-gradient-to-br from-gray-50 to-yellow-50/30 relative overflow-hidden"
    >
      {/* Subtle pattern background */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle at 2px 2px, #1f2937 1px, transparent 0)',
        backgroundSize: '32px 32px'
      }}></div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left: Content */}
          <div>
            <div className="inline-block mb-4 px-4 py-2 bg-yellow-100 rounded-full">
              <span className="text-yellow-700 font-semibold text-sm tracking-wider">INGYENES SZAKMAI ANYAG</span>
            </div>

            <h2 
              data-testid="lead-magnet-heading"
              className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight"
              style={{ fontFamily: 'Montserrat, sans-serif' }}
            >
              Indítsd el a változást
              <span className="text-yellow-600"> tudományos alapokon</span> 
              <span className="block mt-1">– teljesen ingyen!</span>
            </h2>

            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Iratkozz fel az <span className="font-semibold text-gray-900">Orosz Coaching</span> hírlevelére, 
              és töltsd le az ingyenes útmutatómat, amely segít elkerülni a leggyakoribb 
              edzési és táplálkozási hibákat.
            </p>

            <div className="space-y-4 mb-8">
              {principles.map((principle, index) => {
                const Icon = principle.icon;
                return (
                  <div key={index} className="flex items-start gap-4">
                    <div className="bg-yellow-600/10 border border-yellow-600/20 p-2 rounded-lg flex-shrink-0">
                      <Icon className="text-yellow-600" size={20} />
                    </div>
                    <div>
                      <div className="font-semibold text-gray-900">{principle.title}</div>
                      <div className="text-sm text-gray-600">{principle.description}</div>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right: CTA Card */}
          <div className="bg-white rounded-2xl shadow-2xl p-8 md:p-10 border border-gray-100">
            {/* Resource preview card */}
            <div className="bg-gradient-to-br from-gray-900 to-gray-800 text-white rounded-xl p-6 mb-6 relative overflow-hidden">
              <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-600/10 rounded-full -mr-16 -mt-16"></div>
              <div className="flex items-center gap-2 text-yellow-400 text-xs font-bold tracking-widest uppercase mb-3 relative">
                <FileText size={14} />
                Letölthető PDF
              </div>
              <h3 
                className="text-xl md:text-2xl font-bold leading-tight relative" 
                style={{ fontFamily: 'Montserrat, sans-serif' }}
              >
                5 tudományosan igazolt edzési alapelv az 
                <span className="text-yellow-400"> eredményes fizikumépítéshez</span>
              </h3>
            </div>

            <div className="mb-6 text-center">
              <p className="text-gray-700 mb-1">
                <span className="font-semibold">Egyetlen kattintás</span> – és nálad az anyag.
              </p>
              <p className="text-sm text-gray-500">
                E-mail cím megadása után azonnal letölthető.
              </p>
            </div>

            <Link
              to="/ingyenes-pdf"
              data-testid="lead-magnet-cta-btn"
              className="group w-full inline-flex items-center justify-center gap-2 bg-yellow-600 hover:bg-yellow-700 text-white font-bold text-lg py-5 px-6 rounded-md transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-[1.02]"
            >
              <Download size={20} />
              Kérem az ingyenes PDF-et
              <ArrowRight size={18} className="transition-transform group-hover:translate-x-1" />
            </Link>

            <p className="text-xs text-gray-500 text-center mt-4">
              Az adataidat soha nem osztjuk meg senkivel. Bármikor leiratkozhatsz.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LeadMagnetSection;
